import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import driveApi from '../../api/drive';
import { formatSize, kindOf, previewType } from '../../lib/files';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const PreviewDialog = ({ item, onOpenChange, onDownload }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const type = previewType(item);

  useEffect(() => {
    setUrl(null);
    setFailed(false);
    if (!item || !type) return;
    driveApi.downloadUrl([item.id], true).then(setUrl).catch(() => setFailed(true));
  }, [item, type]);

  return (
    <Dialog open={!!item} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[min(88vh,900px)] max-w-[min(1100px,calc(100vw-2rem))] flex-col gap-4 p-5">
        <div className="flex items-center gap-3 pr-12">
          <DialogHeader className="min-w-0 flex-1 pr-0">
            <DialogTitle className="truncate">{item?.name}</DialogTitle>
            <DialogDescription>{kindOf(item).label}, {formatSize(item?.size)}</DialogDescription>
          </DialogHeader>
          <button
            type="button"
            onClick={() => onDownload(item)}
            className="flex h-10 items-center gap-2 rounded-[10px] border border-border px-3.5 font-semibold hover:bg-muted"
          >
            <Download className="h-4 w-4" /> Download
          </button>
        </div>
        <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-xl bg-muted">
          {failed && <p className="text-sm text-muted-foreground">This file can’t be previewed.</p>}
          {!failed && !url && <p className="text-sm text-muted-foreground">Loading preview…</p>}
          {url && type === 'image' && <img src={url} alt={item.name} className="max-h-full max-w-full object-contain" />}
          {url && type === 'video' && <video src={url} controls className="max-h-full max-w-full" />}
          {url && type === 'audio' && <audio src={url} controls className="w-2/3" />}
          {url && (type === 'pdf' || type === 'text') && (
            <iframe src={url} title={item.name} className="h-full w-full border-0 bg-white" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
